var _defs, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverDropzoneBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coverDropzoneBackground_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#767676",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#373737",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "67%",
    stopColor: "#1E1E1E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#999",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#999"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "url(#coverDropzoneBackground_svg__a)",
    strokeWidth: 2,
    x1: "97%",
    y1: "5%",
    x2: "3%",
    y2: "95%"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "url(#coverDropzoneBackground_svg__a)",
    strokeWidth: 2,
    x1: "3%",
    y1: "5%",
    x2: "97%",
    y2: "95%"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImNvdmVyLWRyb3B6b25lLWRpYWdvbmFsLWdyYWRpZW50Ij4KICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzk5OTk5OSIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIyMiUiIHN0b3AtY29sb3I9InJnYigxMTgsIDExOCwgMTE4KSIgc3RvcC1vcGFjaXR5PSIwLjYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMzElIiBzdG9wLWNvbG9yPSJyZ2IoNTUsIDU1LCA1NSkiIHN0b3Atb3BhY2l0eT0iMCIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSI2NyUiIHN0b3AtY29sb3I9InJnYigzMCwgMzAsIDMwKSIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgICA8c3RvcCBvZmZzZXQ9Ijc2JSIgc3RvcC1jb2xvcj0icmdiKDE1MywgMTUzLCAxNTMpIiBzdG9wLW9wYWNpdHk9IjAuNiIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjOTk5OTk5IiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGxpbmUKICAgIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9InVybCgjY292ZXItZHJvcHpvbmUtZGlhZ29uYWwtZ3JhZGllbnQpIgogICAgc3Ryb2tlLXdpZHRoPSIyIgogICAgeDE9Ijk3JSIKICAgIHkxPSI1JSIKICAgIHgyPSIzJSIKICAgIHkyPSI5NSUiCiAgPgogIDwvbGluZT4KICA8bGluZQogICAgZmlsbD0ibm9uZSIKICAgIHN0cm9rZT0idXJsKCNjb3Zlci1kcm9wem9uZS1kaWFnb25hbC1ncmFkaWVudCkiCiAgICBzdHJva2Utd2lkdGg9IjIiCiAgICB4MT0iMyUiCiAgICB5MT0iNSUiCiAgICB4Mj0iOTclIgogICAgeTI9Ijk1JSIKICA+CiAgPC9saW5lPgo8L3N2Zz4K";
export { SvgCoverDropzoneBackground as ReactComponent };